import Vue from "vue";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
export default Vue.extend({
    props: ["user"],
    data() {
        return {
            userId: null,
            dateOriginal: null,
            closedReportsDate: null,
            edit: false,
        };
    },
    mounted() {
        const { userId } = this.$props.user;
        this.$data.userId = userId;
        //@ts-ignore
        this.resetValues();
    },
    methods: {
        async saveValue() {
            try {
                await this.$store.dispatch("adminLockReports", {
                    userId: this.$props.user.userId,
                    closedReportsDate: this.$data.closedReportsDate,
                });
                this.$data.dateOriginal = this.$data.closedReportsDate;
                this.$data.edit = false;
            }
            catch {
                // handle error
                //@ts-ignore
                this.resetValues();
            }
        },
        updateValue(value) {
            this.$data.closedReportsDate = value;
        },
        resetValues() {
            const { closedReportsDate } = this.$props.user;
            this.$data.dateOriginal = closedReportsDate;
            this.$data.closedReportsDate = closedReportsDate;
        },
        cancel() {
            this.$data.edit = false;
            //@ts-ignore
            this.resetValues();
        },
    },
    computed: {
        shortDateOrg() {
            try {
                return window.dateHandler.formatDateNoTime(this.$data.dateOriginal);
            }
            catch {
                return "";
            }
        },
    },
    components: {
        DatePickerTextbox,
    },
});
